module.exports = __webpack_public_path__ + "img/gerente-comercial.41c3a130.png";